import type {RecruiterHubState} from 'src/types/recruiter-hub';


export const RECEIVE_RECRUITER_HUB_INFO = 'recruiter-hub/receive-info';
export const UPDATE_RECRUITER_HUB_INFO = 'recruiter-hub/update-info';
export const RESET_RECRUITER_HUB_STATE = 'recruiter-hub/reset-state';

type RecruiterHubPayload = Partial<RecruiterHubState>;

type ReceiveRecruiterHubInfoAction = {
  type: typeof RECEIVE_RECRUITER_HUB_INFO;
  payload: RecruiterHubPayload;
};

type UpdateRecruiterHubInfoAction = {
  type: typeof UPDATE_RECRUITER_HUB_INFO;
  payload: RecruiterHubPayload;
};

type ResetRecruiterHubStateAction = {
  type: typeof RESET_RECRUITER_HUB_STATE;
};

export type RecruiterHubAction =
  | ReceiveRecruiterHubInfoAction
  | UpdateRecruiterHubInfoAction
  | ResetRecruiterHubStateAction;

export const receiveRecruiterHub = (
  payload: RecruiterHubState,
): ReceiveRecruiterHubInfoAction => ({
  type: RECEIVE_RECRUITER_HUB_INFO,
  payload,
});

export const updateRecruiterHub = (
  payload: RecruiterHubPayload,
): UpdateRecruiterHubInfoAction => ({
  type: UPDATE_RECRUITER_HUB_INFO,
  payload,
});

export const resetRecruiterHub = (): ResetRecruiterHubStateAction => ({
  type: RESET_RECRUITER_HUB_STATE,
});
